import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {  Form, Input, Select, Button } from 'antd';
import { updateProgress, getAllAssignments } from '../../../service/trainingService';

const UpdateTrainingProgress = ({ selectedProgress, handleCancel, handleReload }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [assignments, setAssignments] = useState([]);

  useEffect(() => {
    const fetchAssignments = async () => {
      try {
        const data = await getAllAssignments();
        setAssignments(data);
      } catch (error) {
        console.error('Error fetching assignments:', error);
      }
    };
    fetchAssignments();
  }, []);

  useEffect(() => {
    if (selectedProgress) {
      form.setFieldsValue({
        assignment: selectedProgress.assignment?._id,
        progress: selectedProgress.progress,
        assessmentScore: selectedProgress.assessmentScore,
        certificateEarned: selectedProgress.certificateEarned,
        notes: selectedProgress.notes,
      });
    } else {
      form.resetFields();
    }
  }, [selectedProgress, form]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await updateProgress(values.assignment, {
        progress: values.progress,
        assessmentScore: values.assessmentScore,
        certificateEarned: values.certificateEarned,
        notes: values.notes,
      });
      handleReload();
      handleCancel();
    } catch (error) {
      console.error('Error saving progress:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Form.Item
        name="assignment"
        label="Assignment"
        rules={[{ required: true, message: 'Please select an assignment' }]}
      >
        <Select allowClear showSearch filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
          {assignments.map((assign) => (
            <Select.Option key={assign._id} value={assign._id}>
              {`${assign.employee?.full_name} - ${assign.trainingProgram?.programName}`}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="progress"
        label="Progress (%)"
        rules={[{ required: true, message: 'Please enter progress' }]}
      >
        <Input type="number" min={0} max={100} />
      </Form.Item>
      <Form.Item name="assessmentScore" label="Assessment Score">
        <Input type="number" min={0} max={100} />
      </Form.Item>
      <Form.Item name="certificateEarned" label="Certificate Earned">
        <Select allowClear>
          <Select.Option value={true}>Yes</Select.Option>
          <Select.Option value={false}>No</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item name="notes" label="Notes">
        <Input.TextArea />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          {selectedProgress ? 'Update' : 'Create'} Progress
        </Button>
        <Button onClick={handleCancel} style={{ marginLeft: 8 }}>
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
};

UpdateTrainingProgress.propTypes = {
  selectedProgress: PropTypes.shape({
    assignment: PropTypes.shape({
      _id: PropTypes.string,
    }),
    progress: PropTypes.number,
    assessmentScore: PropTypes.number,
    certificateEarned: PropTypes.bool,
    notes: PropTypes.string,
  }),
  handleCancel: PropTypes.func.isRequired,
  handleReload: PropTypes.func.isRequired,
};

export default UpdateTrainingProgress;